//Validation on the Homepage URL step.
const homepageForm = document.getElementById("homepage-form");
if (homepageForm) {
    homepageForm.addEventListener("submit", validateHomepageForm, false);
}

function validateHomepageForm(event) {
    event.preventDefault();

    //Strip any old error message from the previous validation attempt.
    const errorDiv = document.getElementById("error-message");
    while (errorDiv.firstChild) {
        errorDiv.firstChild.remove();
    }
    errorDiv.classList.remove("error-message--active");

    let valid = true;
    const url = document.getElementById("url_home");
    if (url.value === "" || !isValidURL(url.value)) {
        valid = false;
        url.classList.add("input--error");
    } else {
        url.classList.remove("input--error");
    }

    if (!valid) {
        //Display the error message to enter a valid URL.
        const message = document.createTextNode("Please enter a valid URL.");
        errorDiv.appendChild(message);
        errorDiv.classList.add("error-message--active");
    }

    if (valid) {
        event.currentTarget.submit();

        //Disable the submit button and display a loader.
        const submitButton = document.getElementById("submit-button");
        submitButton.disabled = true;
        submitButton.innerHTML = `<div class="loader-container--small"><div class="loader--small"></div></div>`;
    }
}

//Validation on the accounts step.
const accountForm = document.getElementById("account-form");
if (accountForm) {
    accountForm.addEventListener("submit", validateAccountForm, false);
}

function validateAccountForm(event) {
    event.preventDefault();

    let valid = true;
    let message = "";

    //Strip any old error message from the previous validation attempt.
    const errorDiv = document.getElementById("error-message");
    while (errorDiv.firstChild) {
        errorDiv.firstChild.remove();
    }
    errorDiv.classList.remove("error-message--active");

    //Check a name has been entered.
    const nameInput = document.getElementById("name");
    if (nameInput) {
        if (nameInput.value === "") {
            nameInput.classList.add("input--error");
            message += "Please enter a name. ";
            valid = false;
        } else {
            nameInput.classList.remove("input--error");
        }
    }

    //Check a valid email has been entered.
    const emailInput = document.getElementById("email");
    if (emailInput) {
        const validEmailRegex = /^\S+@\S+$/;
        if (emailInput.value.match(validEmailRegex)) {
            emailInput.classList.remove("input--error");
        } else {
            emailInput.classList.add("input--error");
            message += "Please enter a valid email. ";
            valid = false;
        }
    }

    //Check a valid password has been entered.
    const passwordInput = document.getElementById("password");
    if (passwordInput) {
        if (passwordInput.value.length >= 8) {
            passwordInput.classList.remove("input--error");
        } else {
            passwordInput.classList.add("input--error");
            message += "Password must have at least 8 characters. ";
            valid = false;
        }
    }

    //Check the user has accepted the terms and conditions
    const termsInput = document.getElementById("terms");
    const termsCheckmark = document.getElementById("terms-checkmark");
    if (termsInput.checked) {
        termsCheckmark.classList.remove("checkmark--error");
    } else {
        termsCheckmark.classList.add("checkmark--error");
        message += "Please accept the Terms of Service & Privacy Policy to proceed. ";
        valid = false;
    }

    if (!valid) {
        //Display the error message.
        errorDiv.appendChild(document.createTextNode(message));
        errorDiv.classList.add("error-message--active");
    }

    if (valid) {
        event.currentTarget.submit();

        //Disable the submit button and display a loader.
        const submitButton = document.getElementById("submit-button");
        submitButton.disabled = true;
        submitButton.innerHTML = `<div class="loader-container--small"><div class="loader--small"></div></div>`;
    }
}

//Add URL input to page.
const addButton = document.querySelector(".add-button");
if (addButton) {
    addButton.addEventListener("click", addURL, false);
}

function addURL(urlValue) {
    const urls = document.getElementById("urls");
    const urlComp = document.getElementById("url-component-clone");
    const clonedNode = urlComp.cloneNode(true);
    clonedNode.removeAttribute("id");
    clonedNode.classList.remove("url-component--hidden");
    clonedNode.getElementsByTagName("button")[0].addEventListener("click", removeURL, false);
    const input = clonedNode.querySelector("input");
    if (urlValue && typeof urlValue === "string") {
        input.value = urlValue;
    }
    urls.appendChild(clonedNode);
}

//Remove URL input from page.
const removeButtons = document.getElementsByClassName("remove");
for (let i = 0; i < removeButtons.length; i++) {
    removeButtons[i].addEventListener("click", removeURL, false);
}

function removeURL(event) {
    event.currentTarget.parentNode.remove();
}

//Validate the URLS on the competitors and pages steps of the wizard.
const competitorForm = document.getElementById("competitors-form");
if (competitorForm) {
    competitorForm.addEventListener("submit", validateURLsForm, false);

    fetchCompetitorsJSON().then((urls) => {
        // Remove all empty URL containers.
        const urlContainers = document.getElementById("urls").children;

        // Add competitor URLs.
        if (urls && urls.length) {
            for (const urlContainer of urlContainers) {
                const input = urlContainer.querySelector("input");
                if (!input.value) {
                    urlContainer.style.display = "none";
                }
            }

            urls.map((url) => {
                addURL(url);
            });

            // Display new message (found competitors).
            document.getElementById("state-1").remove();
            document.getElementById("state-2").style.display = "block";
        } else {
            // Display new message (no competitors found).
            document.getElementById("state-1").remove();
            document.getElementById("state-3").style.display = "block";
        }

        // Hide loader.
        const loader = document.querySelector(".loader-container");
        if (loader) {
            loader.remove();
        }
    });

    // pre-fetch pages for next step with a delay to avoid API rate limit errors
    new Promise((resolve) => setTimeout(resolve, 1300)).then(() => {
        fetch("/setup/fetch/?type=pages");
    });
}
async function fetchCompetitorsJSON() {
    const response = await fetch("/setup/fetch/?type=competitors");
    const json = await response.json();
    return json.data ? json.data : [];
}

const pagesForm = document.getElementById("pages-form");
if (pagesForm) {
    pagesForm.addEventListener("submit", validateURLsForm, false);
}

function validateURLsForm(event) {
    event.preventDefault();

    //Strip any old error message from the previous validation attempt.
    const errorDiv = document.getElementById("error-message");
    while (errorDiv.firstChild) {
        errorDiv.firstChild.remove();
    }
    errorDiv.classList.remove("error-message--active");

    const urls = document.getElementsByClassName("input");
    let valid = true;
    for (let i = 0; i < urls.length; i++) {
        const url = urls[i];
        const validURL = isValidURL(url.value);
        if (!validURL) {
            valid = false;
            url.classList.add("input--error");
        } else {
            url.classList.remove("input--error");
        }
    }

    if (!valid) {
        //Display the error message to enter a valid URL.
        const message = document.createTextNode("Please enter a valid URL.");
        errorDiv.appendChild(message);
        errorDiv.classList.add("error-message--active");
    }

    if (valid) {
        event.currentTarget.submit();

        //Disable the submit button and display a loader.
        const submitButton = document.getElementById("submit-button");
        submitButton.disabled = true;
        submitButton.innerHTML = `<div class="loader-container--small"><div class="loader--small"></div></div>`;
    }
}

//Checks if a url is valid
function isValidURL(url) {
    if (url.length === 0) {
        return true;
    }

    if (url.indexOf(".") !== -1) {
        try {
            const urlObject = new URL(url);
            return urlObject.protocol === "http:" || urlObject.protocol === "https:";
        } catch (err) {
            // attempt to fix the URL by prefixing it with protocol if it's missing
            if (url.slice(0, 5) !== "http:" && url.slice(0, 6) !== "https:") {
                url = `https://${url}`;

                // retest
                try {
                    return Boolean(new URL(url));
                } catch (err) {
                    return false;
                }
            }
        }
    }

    return false;
}

const questionsForm = document.getElementById("questions-form");
if (questionsForm) {
    questionsForm.addEventListener("submit", validateQuestionsForm, false);
}

function validateQuestionsForm(event) {
    event.preventDefault();

    //Strip any old error message from the previous validation attempt.
    const errorDiv = document.getElementById("error-message");
    while (errorDiv.firstChild) {
        errorDiv.firstChild.remove();
    }
    errorDiv.classList.remove("error-message--active");

    const challenges = document.getElementsByClassName("checkbox-input");
    let valid = true;
    let challengeSelected = false;
    for (let i = 0; i < challenges.length; i++) {
        const challenge = challenges[i];
        if (challenge.checked) {
            challengeSelected = true;
        }
    }

    const challengesCustomCheckboxes = document.getElementsByClassName("checkmark");
    if (!challengeSelected) {
        valid = false;
        for (let j = 0; j < challengesCustomCheckboxes.length; j++) {
            const challengesCustomCheckbox = challengesCustomCheckboxes[j];
            challengesCustomCheckbox.classList.add("checkmark--error");
        }
    } else {
        for (let k = 0; k < challengesCustomCheckboxes.length; k++) {
            const challengesCustomCheckbox = challengesCustomCheckboxes[k];
            challengesCustomCheckbox.classList.remove("checkmark--error");
        }
    }

    const helpLevel = document.getElementById("help-level");
    if (helpLevel.value !== "") {
        helpLevel.classList.remove("select--error");
    } else {
        valid = false;
        helpLevel.classList.add("select--error");
    }

    const role = document.getElementById("role");
    if (role.value !== "") {
        role.classList.remove("select--error");
    } else {
        valid = false;
        role.classList.add("select--error");
    }

    if (!valid) {
        //Display the error message.
        errorDiv.appendChild(document.createTextNode("Please answer the questions to proceed."));
        errorDiv.classList.add("error-message--active");
    }

    if (valid) {
        event.currentTarget.submit();

        //Disable the submit button and display a loader.
        const submitButton = document.getElementById("submit-button");
        submitButton.disabled = true;
        submitButton.innerHTML = `<div class="loader-container--small"><div class="loader--small"></div></div>`;
    }
}

/*** T&C's confirmation dialog for the social signup buttons ***/
const socialSignupButtons = document.getElementsByClassName("social-signup");
const dialog = document.getElementById("terms-confirmation-dialog");
let confirmButton = null;
if (dialog) {
    confirmButton = dialog.querySelector("#confirm");
}
let redirectUrl;

// Click on button opens the <dialog> modal
Array.prototype.forEach.call(socialSignupButtons, function (element) {
    element.addEventListener("click", (event) => {
        redirectUrl = event.target.href;
        dialog.showModal();
        event.preventDefault();
    });
});

// Prevent the "confirm" button from the default behavior of submitting the form, and close the dialog with the `close()` method, which triggers the "close" event.
if (confirmButton) {
    confirmButton.addEventListener("click", () => {
        event.preventDefault(); // We don't want to submit this fake form
        document.getElementById("terms-confirmation-form").style.display = "none";
        document.getElementById("terms-confirmation-loader").style.display = "block";
        //dialog.close(); // Have to send the select box value here.
        window.location = redirectUrl;
    });
}
